import { __rest } from "tslib";
import * as React from 'react';
import { Field, getIn } from 'formik';
import { Form } from 'antd';



const FormItemChild = (props11) => {
    const { hasError, hasInitialError, isTouched, isValid, showValidateSuccess, restProps, children, showHelp, error, initialError, showInitialErrorAfterTouched } = props11
    const help = React.useMemo(
        () =>
            showHelp &&
            React.createElement(
                React.Fragment,
                null,
                hasError && React.createElement('li', null, error),
                hasInitialError &&
                (!isTouched || showInitialErrorAfterTouched) &&
                React.createElement('li', null, initialError),
            ),
        [error, hasError, hasInitialError, initialError, isTouched, showHelp, showInitialErrorAfterTouched],
    );
    return (React.createElement(Form.Item, {
        validateStatus: hasError || (hasInitialError && !isTouched)
            ? 'error'
            : isValid && showValidateSuccess
                ? 'success'
                : undefined, hasFeedback: isValid, help, ...restProps
    }, children));
}
const FormItemChildMemo = React.memo(FormItemChild)

export const FormItem = (_a) => {
    const { name, showValidateSuccess, showInitialErrorAfterTouched = false, children, validate } = _a; const restProps = __rest(_a, ["name", "showValidateSuccess", "showInitialErrorAfterTouched", "children", "validate"]);
    return (React.createElement(Field, { name, validate }, ({ form: { errors = {}, touched = {}, initialErrors = {} }, }) => {
        const error = getIn(errors, name, undefined);
        const initialError = getIn(initialErrors, name, undefined);
        let isTouched = Boolean(getIn(touched, name, false));
        // https://github.com/commercetools/ui-kit/blob/08a6045381d633e44c3494b41c7d6763104366fb/src/components/inputs/select-input/select-input.js#L27-L29
        // https://github.com/formium/formik/issues/1712
        const hasError = error !== undefined && isTouched;
        const hasInitialError = initialError !== undefined;
        const isValid = !error && isTouched;
        const showHelp = hasError ||
            (hasInitialError && (!isTouched || showInitialErrorAfterTouched));
        return React.createElement(FormItemChildMemo, { hasError, hasInitialError, isTouched, isValid, showValidateSuccess, restProps, showHelp, error, initialError, showInitialErrorAfterTouched }, children)
    }));
};
export default FormItem;
//# sourceMappingURL=index.js.map